import { FormikHelpers } from "formik";
import { INotificationFormValues } from "../schema/notifications.schema";
import { QuillModules } from "@components/QuillEditor";

export interface IFormHookValues {
  loading: boolean;

  initialValues: INotificationFormValues | undefined;
  previewOpen: boolean;

  isCreate: boolean;
  isEdit: boolean;
  isView: boolean;
  mode: INotificationFormMode;
}

export interface IFormHookActions {
  handleCancelOrClose: () => void;
  handleSubmit: (
    values: INotificationFormValues,
    helpers: FormikHelpers<INotificationFormValues>
  ) => Promise<void>;
  handlePreview: (values: INotificationFormValues) => void;
  closePreview: () => void;
}

export interface IActionRules {
  showCancel: boolean;
  showPreview: boolean;
  showSubmit: boolean;
  submitLabel?: string;
}

export type INotificationFormMode = "create" | "edit" | "view";
export enum NotificationFormModeEnum {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
export const { CREATE, EDIT, VIEW } = NotificationFormModeEnum;

export enum FormFieldEnum {
  TITLE = "title",
  CONTENT = "content",

  CENTERS = "centers",
  SEGMENTS = "segments",
  PROFILES = "profiles",

  START_AT = "startAt",
  EXPIRE_AT = "expireAt",

  FILE_KEY = "fileKey",
  FILE_TYPE = "fileType",
}

export const richTextModules: QuillModules = {
  imageDropAndPaste: {
    handler: () => {},
  },
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
    ],
  },
  clipboard: {
    matchVisual: false,
    matchers: [["img", () => ({ ops: [] })]],
  },
};
